var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"auth-layout",style:({ 'background-image': 'url(' + require('@/assets/images/background-1.png') + ')' })},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }